import './style.less'
import { Checkbox } from 'antd'

export default Checkbox
